// Recovered compiled webpack factory 13314. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "escapeStringRegexp", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let r = /[|\\{}()[\]^$+*?.-]/,
    n = /[|\\{}()[\]^$+*?.-]/g;
  function a(e) {
    return r.test(e) ? e.replace(n, "\\$&") : e;
  }
}
